import { render } from "./FilterPropinsi.vue?vue&type=template&id=3e151098"
import script from "./FilterPropinsi.vue?vue&type=script&lang=js"
export * from "./FilterPropinsi.vue?vue&type=script&lang=js"
script.render = render

export default script